import script from "./CoverageList.vue?vue&type=script&setup=true&lang=js"
export * from "./CoverageList.vue?vue&type=script&setup=true&lang=js"

import "./CoverageList.vue?vue&type=style&index=0&id=427f9f54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427f9f54"]])

export default __exports__